import { Box, Skeleton } from '@mui/material';
import { SKELETON_WIDTHS } from './taxonomyTreeConstants';

export const LoadingIndicator = ({ count = 3 }: { count?: number }) => (
  <Box sx={{ py: 0.5, pl: 3 }}>
    {Array.from({ length: count }, (_, index) => (
      <Skeleton key={index} variant='text' width={SKELETON_WIDTHS[index % SKELETON_WIDTHS.length]} height={28} />
    ))}
  </Box>
);
